<template>
  <div class="w-100 grid-container">
    <configuration-section-header
      class="my-0"
      :section-icon="'far fa-star'"
      section-title="Mockup section"
      @changedPageSize="changedPageSize($event)"
      @changedMode="changedMode($event)"
    >
      <!-- TODO: Pendiente de enlazar por parte de Front -->
      <b-button
        v-tooltip="$t('configuration.actions.activate')"
        :disabled="!canActivateBatch"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
      >
        <i
          class="far fa-check-circle"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-tooltip="$t('configuration.actions.deactivate')"
        :disabled="!canDeactivateBatch"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
      >
        <i
          class="far fa-times-circle"
          aria-hidden="true"
        />
      </b-button>
      <div
        style="width:1px; height:18px; background: #d0d0d0"
        class="mx-3"
      />
      <b-button
        v-tooltip="$t('configuration.actions.delete')"
        :disabled="selectedRows.length < 1"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="deleteMorphology()"
      >
        <i
          class="far fa-trash-alt"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-tooltip="$t('configuration.actions.update')"
        :disabled="selectedRows.length !== 1"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="showSectionConfigurationModal($t('configuration.actions.update'))"
      >
        <i
          class="far fa-edit"
          aria-hidden="true"
        />
      </b-button>
      <b-button
        v-tooltip="$t('configuration.actions.add')"
        class="btn__icon btn__icon--primary px-2 py-0"
        variant="link"
        @click="showSectionConfigurationModal($t('configuration.actions.add'))"
      >
        <i
          class="far fa-plus"
          aria-hidden="true"
        />
      </b-button>
    </configuration-section-header>
    <div class="flex-grow-1">
      <vt-grid
        pagination
        class="configuration-grid"
        :grid-options="gridOptions"
        :row-data="rowData"
        :column-defs="columnDefs"
        :component-code="gridUiComponent"
      />
    </div>
    <section-configuration-modal
      ref="sectionConfigurationModal"
      :action-title="actionTitle"
    />
  </div>
</template>

<script>
import ConfigurationSectionHeader from '@/modules/configurationModule/ConfigurationSectionHeader'
import VtGrid from '@/components/VtGrid/VtGrid'
import columnsSectionGrid from '@/modules/configurationModule/detail/print/section/columnsSectionGrid'
import SectionConfigurationModal from '@/modules/configurationModule/detail/print/section/SectionConfigurationModal'
import gridSideBarConfig from '@/grid/gridSideBarConfig'
import { AgGridRowModelType } from '@/shared/models/ag-grid.model'

export default {
    name: 'SectionConfigurationGrid',
    components: {
        ConfigurationSectionHeader,
        VtGrid,
        SectionConfigurationModal
    },
    data() {
        return {
            actionTitle: null,
            selectedRows: [],
            columnDefs: columnsSectionGrid(),
            rowData: [
                {
                    column1: 'data',
                    column2: 'data',
                    active: true
                },
                {
                    column1: 'data',
                    column2: 'data',
                    active: true
                },
                {
                    column1: 'data',
                    column2: 'data',
                    active: true
                },
                {
                    column1: 'data',
                    column2: 'data',
                    active: true
                }
            ]
        }
    },
    computed: {
        gridOptions() {
            return {
                sideBar: gridSideBarConfig,
                rowModelType: AgGridRowModelType.CLIENT_SIDE,
                getContextMenuItems: this.getContextMenuItems,
                onGridReady: this.onGridReady,
                onSelectionChanged: this.onSelectionChanged
            }
        }
    },
    methods: {
        getContextMenuItems(params) {
            if (!params?.node) {
                return []
            } else {
                return [
                    {
                        name: this.$t('configuration.actions.update'),
                        cssClasses: this.selectedRows.length > 1 ? ['not-show'] : '',
                        action: () => this.showSectionConfigurationModal(this.$t('configuration.actions.update'))
                    },
                    {
                        name: this.$t('configuration.actions.delete'),
                        cssClasses: this.selectedRows.length < 1 ? ['not-show'] : '',
                        action: () => this.deleteMorphology()
                    },
                    {
                        name: this.$t('configuration.actions.activate'),
                        cssClasses: this.selectedRows.length > 1 ? ['not-show'] : ''
                        // TODO: Debe cambiar entre Activar o Desactivar según cómo esté el elemento actualmente
                    },
                    {
                        name: this.$t('configuration.actions.activate'),
                        cssClasses: this.selectedRows.length <= 1 ? ['not-show'] : ''
                        // TODO: Comportamiento de Activar Todo, cuando hay varios elementos seleccionados
                    },
                    {
                        name: this.$t('configuration.actions.deactivate'),
                        cssClasses: this.selectedRows.length <= 1 ? ['not-show'] : ''
                        // TODO: Comportamiento de Desactivar Todo, cuando hay varios elementos seleccionados
                    }
                ]
            }
        },
        onSelectionChanged({ api }) {
            this.selectedRows = api.getSelectedRows()
        },
        onGridReady({ api }) {
            this.gridApi = api
        },
        showSectionConfigurationModal(title) {
            this.actionTitle = title
            this.$refs.sectionConfigurationModal.show()
        },
        async deleteMorphology() {
            await this.showConfirmationModalGlobal(`${this.$t('configuration.grid.deleteConfirmation')} ${this.selectedRows.length} ${this.$tc('configuration.grid.element', this.selectedRows.length)}, <br/> ${this.$t('configuration.grid.deleteQuestion')}`, this.$t('configuration.actions.delete'))
        },
        changedPageSize() { },
        changedMode() { }
    }
}
</script>
